import ACCESS from "~/core/access";
import { me, store } from "~/core/store";
import HelpModeTooltip from "./HelpModeTooltip";
import Receipt from "@material-design-icons/svg/outlined/receipt_long.svg";
import Schedule from "@material-design-icons/svg/outlined/schedule.svg";
import Approval from "@material-design-icons/svg/outlined/task_alt.svg";
import Calculate from "~/assets/menu/calculate.svg";
import Dashboard from "~/assets/menu/dashboard.svg";
import Help from "~/assets/menu/help.svg";
import Inbox from "~/assets/menu/inbox.svg";
import Media from "~/assets/menu/media.svg";
import Profile from "~/assets/menu/profile.svg";
import Project from "~/assets/menu/project.svg";
import Settings from "~/assets/menu/settings.svg";

const top = () => [
    {
        feature: "dashboard",
        path: me("dashboard"),
        icon: Dashboard,
        label: "Dashboard",
        access: ACCESS.dashboard,
    },
    {
        path: me("admin"),
        icon: Project,
        label: "Employee functions",
        access: [
            ACCESS.adminTime,
            ACCESS.adminExpenses,
            ACCESS.adminApproval,
            ACCESS.adminTasks,
        ],
        accessAny: true,
    },
    {
        path: me("projects"),
        icon: Media,
        label: "Projects",
        access: ACCESS.projects,
        hidden: true,
    },
    {
        path: me("resources"),
        icon: Calculate,
        label: "Resource planning",
        access: ACCESS.resources,
        hidden: true,
    },
    {
        path: me("chat"),
        icon: Inbox,
        label: "Inbox",
        access: ACCESS.chat,
        hidden: true,
    },
];

const bottom = () => [
    {
        path: me("settings"),
        icon: Settings,
        label: "Settings",
        access: ACCESS.settings,
        hidden: true,
    },
    {
        icon: Help,
        label: "Help",
        tooltip: <HelpModeTooltip />,
        access: ACCESS.help,
        isActive: store.help.isDiscovery,
        onClick: () =>
            (store.help.isDiscovery.value = !store.help.isDiscovery.peek()),
    },
    {
        path: me("profile"),
        icon: Profile,
        label: "Profile",
        access: ACCESS.profile,
    },
];

const mobile = () => [
    {
        path: me("dashboard"),
        icon: Dashboard,
        label: "Dashboard",
        access: ACCESS.dashboard,
    },
    {
        path: me("admin/time"),
        icon: Schedule,
        label: "Time reporting",
        access: ACCESS.adminTime,
    },
    {
        path: me("admin/expenses"),
        icon: Receipt,
        label: "Expenses",
        access: ACCESS.adminExpenses,
    },
    {
        path: me("admin/approval"),
        icon: Approval,
        label: "Approvals",
        access: ACCESS.adminApproval,
    },
    {
        path: me("projects"),
        icon: Project,
        label: "Projects",
        access: ACCESS.projects,
    },
    {
        path: me("profile?tab=settings"),
        icon: Profile,
        label: "Profile",
        access: ACCESS.profile,
    },
];

const navigation = { top, bottom, mobile };

export default navigation;
